import { ReactNode, useState, useCallback, createContext } from 'react';
import { BulkActionType } from '../../hooks/useBulkActionMessages/types';

export interface BulkActionsContext {
  selectedRowsId: string[];
  selectedAction: BulkActionType | null;
  setSelectedRowsId: (ids: string[]) => void;
  setSelectedAction: (action: BulkActionType) => void;
  clearBulkActions: () => void;
  showModal: boolean;
  openModal: () => void;
  closeModal: () => void;
  editMode: boolean;
  toggleEditMode: () => void;
}

export const BulkActionsContext = createContext({} as BulkActionsContext);

interface BulkActionsContextProviderParams {
  children: ReactNode;
}

function BulkActionsContextProvider({
  children,
}: BulkActionsContextProviderParams): JSX.Element {
  const [rowsId, setRowsId] = useState([]);
  const [action, setAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const setSelectedRowsId = useCallback((ids) => setRowsId(ids), []);
  const setSelectedAction = useCallback((action) => setAction(action), []);

  const openModal = useCallback(() => setShowModal(true), []);
  const closeModal = useCallback(() => setShowModal(false), []);

  const toggleEditMode = useCallback(
    () => setEditMode((current) => !current),
    [],
  );

  const clearBulkActions = useCallback(() => {
    setRowsId([]);
    setAction(null);
  }, []);

  return (
    <BulkActionsContext.Provider
      value={{
        selectedRowsId: rowsId,
        selectedAction: action,
        setSelectedRowsId,
        setSelectedAction,
        clearBulkActions,
        showModal,
        openModal,
        closeModal,
        editMode,
        toggleEditMode,
      }}
    >
      {children}
    </BulkActionsContext.Provider>
  );
}

export default BulkActionsContextProvider;
